// extracted by mini-css-extract-plugin
export default {"wrapper":"_ece54ac5","container":"_8b792f91","contact1stdibs":"_255b413c","contact1Stdibs":"_255b413c","hoveredNavigation":"_306444fb"};